import styled from 'styled-components';

export const Checkbox = styled.label`
    display: inline-flex;
    align-items: center;
    position: relative;
    width: fit-content;
    gap: 8px;
`;

export const Box = styled.div<{ $checked: boolean; $error?: boolean }>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 20px;
    color: ${({ theme }) => theme.text.white};
    background-color: ${({ theme, $checked }) => $checked && theme.colors.gold400};
    border-radius: 2px;
    border: 1px solid ${({ theme, $checked }) => ($checked ? theme.colors.gold400 : theme.border.dark)};
    ${({ theme, $error }) => ($error ? `outline: 2px solid ${theme.intent.negative}` : '')}
`;

export const CheckInput = styled.input`
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;

    &:disabled ~ ${Box} {
        cursor: not-allowed;
        opacity: 0.5;

        &:hover {
            box-shadow: none;
        }
    }
`;
